module.exports = __webpack_public_path__ + "media/images/logo/ups-0a7068597b1b270fc9cca7a9a58cb011.gif";